// src/app/_components/ui/use-media-query.ts
"use client"

import * as React from "react"

/**
 * Subscribe to a CSS media query. Returns `false` during SSR and the first
 * client render, then the live match on the client. Matches the dashboard
 * `sm` breakpoint (640px) by default.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [query])

  return matches
}

/** True on the `sm` breakpoint and up (≥ 640px) — desktop/tablet. */
export function useIsDesktop(): boolean {
  return useMediaQuery("(min-width: 640px)")
}
